var _desc, _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamkittyMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "TeamKitty TK sport mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A sporty TK monogram with an orbit ring in navy, orange and white.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 112,
    fill: "#0B1C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 275C88 191 149 109 236 96C296 88 354 112 390 159",
    stroke: "#FFFFFF",
    strokeWidth: 28,
    strokeLinecap: "round",
    opacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M407 236C424 323 363 405 276 418C217 427 160 404 124 360",
    stroke: "#F59E0B",
    strokeWidth: 28,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 184H314L281 227H221L174 369H116L162 227H96L111 184Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281 184H347L281 260L386 369H316L242 289L281 184Z",
    fill: "#F59E0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236 278L193 331L211 277L257 227H304L236 278Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamkittyMark);
export default __webpack_public_path__ + "static/media/teamkitty-mark.dd8dbca5a298bd6f952aa43f818e676e.svg";
export { ForwardRef as ReactComponent };